export default __webpack_public_path__ + "static/media/comments.7a880a2c.svg";